export default __webpack_public_path__ + "static/media/hht2_ep20_book_wp_02.efd92e16.jpg";